import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError } from 'src/toolkit';

import { useAppDispatch, useAppSelector } from '../../hooks';


export type TToastOptional = {
	text?: string;
	type?: boolean;
};

export type TToast = {
	id: number;
	isActive: boolean;

	text: string;
	type: boolean;
};

export const sendToast = createAsyncThunk(
	`TOAST`,
	(payload: TToastOptional, thunkApi) => {
		const dispatch = useAppDispatch();

		const { text = '', type = false } = payload;

		const data = {
			id: Date.now(),
			isActive: false,

			text,
			type,
		};

		console.log(data);

		dispatch(addToast(data));
		dispatch(showToast(data));

		return new Promise((resolve, reject) => {
			setTimeout(() => {
				console.log('resolve showToast');
				resolve(null);
			}, 4000);
		}).then(result => {
			dispatch(hideToast(data));

			return new Promise((resolve, reject) => {
				setTimeout(() => {
					console.log('resolve hideToast');
					resolve(null);
				}, 1000) }
			).then(result => {
				console.log('resolve II removeToast');
				dispatch(removeToast(data));

				return null;
			}).catch((error: Error) => {
				return thunkApi.rejectWithValue({ ...error });
			});

		}).catch((error: Error) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TToast[] = [];

export const toastSlice = createSlice({
	name: 'toastSlice',
	initialState,
	reducers: {
		addToast(state, action: PayloadAction<TToast>) {
			console.log('addToast');
			const previousStringValue = JSON.stringify(initialState);
			const previousValue = JSON.parse(previousStringValue);

			previousValue.push({ ...action.payload });

			state = previousValue;
		},

		showToast(state, action: PayloadAction<TToast>) {
			console.log('showToast');
			const stringValue = JSON.stringify(initialState);
			const value: TToast[] = JSON.parse(stringValue);

			const { id } = action.payload;

			const existed = value.find(item => item.id === id);

			if (existed) {
				existed.isActive = true;

				state = value;
			}
		},

		hideToast(state, action: PayloadAction<TToast>) {
			console.log('hideToast');
			const stringValue = JSON.stringify(initialState);
			const value: TToast[] = JSON.parse(stringValue);

			const { id } = action.payload;

			const existed = value.find(item => item.id === id);

			if (existed) {
				existed.isActive = false;

				state = value;
			}
		},

		removeToast(state, action: PayloadAction<TToast>) {
			console.log('removeToast');
			const { id } = action.payload;
			const value = state.filter(item => item.id !== id);

			state = value;
		},

		clearToastList(state) {
			return [];
		},
	},

	extraReducers: {
		[sendToast.pending.type]: (state) => {
			console.log('TOAST PENDING ERROR');
		},

		[sendToast.fulfilled.type]: (state, action: PayloadAction<TToast>) => {
			console.log('TOAST FULFILLED');
			removeToast(action.payload);
		},

		[sendToast.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			console.log('TOAST REJECTED ERROR');
		},
	},
});

export const useToastSelector = () => useAppSelector(state => state[toastSlice.name]);

export const { addToast, showToast, hideToast, removeToast, clearToastList } = toastSlice.actions;
